export default {
    startingBalance: 3,
    queryRetryCount: 3,
    popupContainerId: 'popup-root',
    feedbackIdleTimeout: 15000,
    wordsPerPage: 250,
    topupPopupThreshold: 3,
};
